import axios from "axios";
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";
import lgVideo from "lightgallery/plugins/video";
const $ = window.jQuery;
const $window = window.$window || $( window );

export default {
  init() {
    // JavaScript to be fired on the home page
    console.log('single community');

    ( function( $ ) {

      const url = 'https://snyderhomes.test/wp-json/wp/v2/plans'

      let activeIds = 995

        function loadFloorplans() {
         $.ajax({
           url: url,
           dataType: 'json',
           success(res) {
             let rr = res

             let plans = rr.filter(plan => plan.acf.plan_communities.id == 955);
             //
             // const result = rr.filter((item) => item.acf);
             // rr.map(item => console.log(item.acf.plan_communities.id == '865'));

             console.log(plans)
           }
         })
        }

      Fancybox.bind('[data-fancybox="gallery_lightbox_plans"]', {
        Image: {
          zoom: true,
        },
      });

      lightGallery(document.getElementById('plan-video'), {
        plugins: [lgVideo],
      });

      window.addEventListener( 'load', ( event ) => {
        loadFloorplans();
      } );

    })( jQuery );





    // const getGalleryImages = async () => {
    //   try {
    //     const response = await axios.get(url);
    //     const data = response.data;
    //
    //     const result = data.filter(({id}) => activeIds.includes(id));
    //
    //
    //
    //
    //     console.log(data)
    //
    //     return data;
    //
    //   } catch(err) {
    //     console.error(err)
    //   }
    // }
    //
    // getGalleryImages();

    ( function( $ ) {
      /**
       * initMap
       *
       * Renders a Google Map onto the selected jQuery element
       *
       * @date 22/10/19
       * @param $el
       * @since 	5.8.6
       * @param jQuery $el The jQuery element.
       * @return 	object The map instance.
       */
      function initMap( $el ) {
        // Find marker elements within map.
        const $markers = $el.find( '.marker' );

        // Create gerenic map.
        const mapArgs = {
          zoom: $el.data( 'zoom' ) || 16,
          mapTypeId: google.maps.MapTypeId.ROADMAP,

        };
        const map = new google.maps.Map( $el[ 0 ], mapArgs );

        // Add markers.
        map.markers = [];
        $markers.each( function() {
          initMarker( $( this ), map );
        } );

        // Center map based on markers.
        centerMap( map );

        // Return map instance.
        return map;
      }

      /**
       * initMarker
       *
       * Creates a marker for the given jQuery element and map.
       *
       * @date 22/10/19
       * @since 	5.8.6
       * @param $marker
       * @param map
       * @param jQuery $el The jQuery element.
       * @param object The map instance.
       * @return 	object The marker instance.
       */
      function initMarker( $marker, map ) {
        // Get position from marker.
        const lat = $marker.data( 'lat' );
        const lng = $marker.data( 'lng' );
        const latLng = {
          lat: parseFloat( lat ),
          lng: parseFloat( lng ),
        };

        // Create marker instance.
        const marker = new google.maps.Marker( {
          position: latLng,
          map,
          // icon: 'https://newhomeinc1dev.wpengine.com/wp-content/uploads/2022/01/google-map-marker.png',
        } );

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if ( $marker.html() ) {
          // Create info window.
          const infowindow = new google.maps.InfoWindow( {
            content: $marker.html(),
          } );

          // Show info window when marker is clicked.
          google.maps.event.addListener( marker, 'click', function() {
            infowindow.open( map, marker );
          } );
        }
      }

      /**
       * centerMap
       *
       * Centers the map showing all markers in view.
       *
       * @date 22/10/19
       * @param map
       * @since 	5.8.6
       * @param object The map instance.
       * @return 	void
       */
      function centerMap( map ) {
        // Create map boundaries from all map markers.
        const bounds = new google.maps.LatLngBounds();
        map.markers.forEach( function( marker ) {
          bounds.extend( {
            lat: marker.position.lat(),
            lng: marker.position.lng(),
          } );
        } );

        // Case: Single marker.
        if ( map.markers.length == 1 ) {
          map.setCenter( bounds.getCenter() );

          // Case: Multiple markers.
        } else {
          map.fitBounds( bounds );
        }
      }

      //Render maps on page load.
      $( document ).ready( function() {
        $( '.acf-map' ).each( function() {
          const map = initMap( $( this ) );
        } );
      } );

      // $( document ).on( 'facetwp-loaded', function() {
      //   $( '.acf-map' ).each( function() {
      //     const map = initMap( $( this ) );
      //   } );
      // } );
    }( jQuery ) );
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS


  },
};
